import React from 'react';
import { createRoot } from 'react-dom/client';
import Root from './app.jsx';
import './styles.css';
import './lib/install.js';
import { initAnalytics } from './lib/analytics.js';

// Registered unconditionally (not just when push is enabled) so the app
// meets Chrome's installability criteria — a controlling service worker
// is required before Chrome will fire `beforeinstallprompt` / allow
// "Add to Home screen", which is what lets the app hide the address bar.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/push-sw.js').catch(() => {});
}

initAnalytics();

createRoot(document.getElementById('root')).render(<Root/>);
